import React, { useState,useEffect } from "react";
import ApplyLeaveModal from "../../components/ApplyLeaveModal";
import { UseHrApp } from "../../utils/context";
import axios from "axios";
import EmployeeLeaves from "../../components/EmployeeLeavesTable";


export default function EmLeaves() {






  return (
    <div className=" min-w-screen min-h-[95vh]  bg-[#f4f8fd] font-[Archivo]">
      <div className=" p-3 md:pl-[15em] lg:pl-[15em] lg:pr-[.8em] xl:pl-[16em] xl:pr-[2em] w-full pt-[1em] ">
        <div className=" w-full flex justify-between items-center mb-7">
      <div>
      <p className=" font-[Archivo] md:text-lg lg:text-2xl font-semibold ">
            Leaves
          </p>
          <p></p>
      </div>

          <ApplyLeaveModal />
        </div>

        <div className="  grid lg:grid-cols-3 lg:grid-rows-1 gap-6 ">
          <div className="w-full flex flex-col gap-3 p-3 bg-white box2 rounded-md">
            <div className=" flex justify-between w-full items-center">
              <p className=" lg:text-lg xl:text-xl font-semibold">
                Bereavement Leave
              </p>
            </div>

            <div className=" flex justify-between w-full text-[#666666]">
              <p>
                {" "}
                Take time off from work to grieve and cope with the loss of an
                immediate family member, such as a spouse, child, parent, or
                sibling.{" "}
              </p>
            </div>
          </div>

          <div className="w-full flex flex-col gap-3 p-3 bg-white box2 rounded-md">
            <div className=" flex justify-between w-full">
              <p className="lg:text-lg xl:text-xl font-semibold">Sick Leave</p>
            </div>

            <div className=" flex justify-between w-full text-[#666666]">
              <p>
                {" "}
                Take time off from work when they are ill or injured and unable
                to perform their job duties.{" "}
              </p>
            </div>
          </div>

          <div className="w-full flex flex-col gap-3 p-3 bg-white box2 rounded-md">
            <div className=" flex justify-between w-full">
              <p className="lg:text-lg xl:text-xl font-semibold">
                Casual Leave
              </p>
            </div>

            <div className=" flex justify-between w-full text-[#666666]">
              <p>
                Take time off from work for unforeseen or personal reasons that
                do not fall under other specific leave categories.
              </p>
            </div>
          </div>
        </div>

        <div className=" mt-8">
          <div>
            <p className=" md:text-xl lg:text-2xl font-semibold font-[Archivo]">
              History
            </p>
<section>
  <EmployeeLeaves/>
</section>

          </div>
        </div>
      </div>
    </div>
  );
}
